import React from "react";
import EditIcon from "@mui/icons-material/Edit";
import ClearIcon from "@mui/icons-material/Clear";
import Box from "@mui/material/Box";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import AddIcon from "@mui/icons-material/Add";
import axios from "axios";
import SweetAlert from "react-bootstrap-sweetalert";
import Pagination from "../../Pagination/Pagination";
import { useAppContext } from "../../Lib/ContextLib";
import { API_URL } from "../../config";
import Loader from "../Loader/Loader";
import EmptyState from "../../Components/EmptyState";
import CustomSelect from "../../Components/CustomSelect";
import moment from "moment";

const parseFloatSafe = (val) => {
  if (val === undefined || val === null || val === "") return 0;
  const parsed = parseFloat(val);
  return isNaN(parsed) ? 0 : parsed;
};

export default function Candy() {
  const { showPage, setShowPage, accessObject } = useAppContext();
  const { socket } = useAppContext();
  const [alert, setAlert] = React.useState(null);
  const [tableData, setTableData] = React.useState([]);
  const [rowValue, setRowValue] = React.useState();
  const [openValue, setOpenValue] = React.useState(0);
  const [loader, setLoader] = React.useState(false);
  const [buttonLoader, setbuttonLoader] = React.useState(false);
  const [showPrePage, setShowPrePage] = React.useState(10);
  const [pagination, setPagination] = React.useState({
    start: 0,
    end: showPrePage,
  });
  

  const onPaginationChange = (start, end) => {
    setPagination({ start: start, end: end });
  };

  const TournamentSchema = Yup.object().shape({
    table_name: Yup.string().required("Required"),
    players: Yup.number().required("Required"),
    prize1: Yup.number().required("Required"),
    interval: Yup.number().required("Required"),
    game_time: Yup.number().required("Required"),
    amount: Yup.number().required("Required"),
    bonusAmount: Yup.number().required("Required"),
    bot: Yup.number().required("Required"),
    botComplexity: Yup.number().required("Required"),
    active: Yup.boolean().required("Required"),
  });

  React.useEffect(() => {
    getTournamentData();
  }, []);

  const getTournamentData = () => {
    setLoader(true);
    axios(`${API_URL}/api/admin/tournament/get-candy-table`, {
      method: "GET",
      credentials: "include",
    })
      .then((response) => {
        setLoader(false);
        setTableData(response.data.data);
        console.log("response.data::: ", response.data);
      })
      .catch((error) => {
        console.log("getTournamentData error:", error);
        setLoader(false);
      });
  };

  const clickEditButton = (item) => {
    setShowPage(true);
    setRowValue(item);
    setOpenValue(2);
  };

  const openAddTournament = (value) => {
    setRowValue();
    setShowPage(true);
    setOpenValue(value);
  };

  const updateShowPerpagevalue = (value) => {
    setShowPrePage(value);
    setPagination({ start: 0, end: value });
  };

  const updateTournament = (value) => {
    const mergedData = { ...value, id: rowValue._id };
    axios
      .patch(
        `${API_URL}/api/admin/tournament/update-candy-table/${rowValue._id}`,
        mergedData
      )
      .then((res) => {
        const data = {
          message: "candy",
        };
        if (res.data.status) {
          successEdit();
          socket.emit("tournamentUpdate", data);
          setbuttonLoader(false);
        }
      })
      .catch((err) => {
        console.log("update error:", err);
        setbuttonLoader(false);
      });
  };

  const addNewTournament = (value) => {
    axios(`${API_URL}/api/admin/tournament/add-candy-table`, {
      method: "POST",
      credentials: "include",
      data: value,
    })
      .then((result) => {
        const data = {
          message: "candy",
        };
        if (result.data.status) {
          successAdd();
          socket.emit("tournamentAdd", data);
          setbuttonLoader(false);
        }
      })
      .catch((err) => {
        console.log("handleSubmit error:", err);
        setbuttonLoader(false);
      });
  };

  const warningWithConfirmMessage = (e) => {
    setAlert(
      <SweetAlert
        custom
        showCancel
        confirmBtnText="Yes, Delete"
        cancelBtnText="Cancel"
        confirmBtnBsStyle="danger"
        cancelBtnBsStyle="default"
        onConfirm={() => {
          deleteData(e);
          setAlert(null);
        }}
        onCancel={() => setAlert(null)}
        customClass="premium-alert" btnSize="md" title=""
        confirmBtnClass="premium-alert-confirm bg-danger shadow-danger"
        cancelBtnClass="premium-alert-cancel"
        customIcon={<div className="mb-4" style={{ fontSize: '50px', color: '#dc3545' }}><i className="fas fa-trash-alt"></i></div>}
      >
        <div className="premium-alert-title">Are you sure?</div>
        <p className="premium-alert-text">You are about to delete this tournament record. This action cannot be undone.</p>
      </SweetAlert>
    );
  };

  const successDeleted = () => {
    setAlert(
      <SweetAlert
        success
        onConfirm={() => {
          getTournamentData();
          setAlert(null);
          const data = {
            message: "candy",
          };
          socket.emit("tournamentDelete", data);
          setbuttonLoader(false);
        }}
        customClass="premium-alert" btnSize="md" title=""
        confirmBtnClass="premium-alert-confirm"
      >
        <div className="premium-alert-title">Deleted!</div>
        <p className="premium-alert-text">The tournament record has been successfully removed.</p>
      </SweetAlert>
    );
  };

  const deleteData = (e) => {
    setbuttonLoader(true);
    axios
      .delete(`${API_URL}/api/admin/tournament/delete-candy-table/${e._id}`)
      .then((res) => {
        if (res.data.status) {
          successDeleted();
        }
      });
  };

  const successAdd = () => {
    setAlert(
      <SweetAlert
        success
        style={{ display: "block" }}
        title="Added successfully!"
        onConfirm={() => {
          getTournamentData();
          setAlert(null);
          setShowPage(false);
        }}
        confirmBtnBsStyle="success"
      >
        Your Tournament Record has been Added...
      </SweetAlert>
    );
  };

  const successEdit = () => {
    setAlert(
      <SweetAlert
        success
        style={{ display: "block" }}
        title="Edited successfully!"
        onConfirm={() => {
          getTournamentData();
          setAlert(null);
          setShowPage(false);
        }}
        confirmBtnBsStyle="success"
      >
        Your Tournament Record has been Edited...
      </SweetAlert>
    );
  };

  return (
    <>
      {alert}
      {showPage ? (
        <div className="content p-3">
          <div className="card p-3">
            <Box sx={{ width: "100%" }}>
              <Formik
                initialValues={{
                  table_name: rowValue ? rowValue?.table_name : "",
                  players: rowValue ? rowValue?.players : 2,
                  prize1: rowValue ? rowValue?.prize1 : 0,
                  interval: rowValue ? rowValue?.interval : 0,
                  game_time: rowValue ? rowValue?.game_time : 0,
                  amount: rowValue ? rowValue?.amount : 0,
                  bonusAmount: rowValue ? rowValue?.bonusAmount : 0,
                  bot: rowValue ? rowValue?.bot : 0,
                  botComplexity: rowValue ? rowValue?.botComplexity : 0,
                  active: rowValue ? rowValue?.active : true,
                }}
                validationSchema={TournamentSchema}
                onSubmit={(values) => {
                  setbuttonLoader(true);
                  const parsedValues = {
                    ...values,
                    prize1: parseFloatSafe(values.prize1),
                    amount: parseFloatSafe(values.amount),
                    bonusAmount: parseFloatSafe(values.bonusAmount),
                  };
                  if (openValue === 1) {
                    addNewTournament(parsedValues);
                  }
                  if (openValue === 2) {
                    updateTournament(parsedValues);
                  }
                }}
              >
                {({ touched, errors, values, setFieldValue }) => (
                  <Form>
                    <div className="row">
                      {/* Basic Info */}
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Table Name <span className="text-danger">*</span></label>
                          <Field
                            type="text"
                            name="table_name"
                            placeholder="Enter Table Name"
                            className={`mt-1 form-control ${touched.table_name && errors.table_name ? "is-invalid" : ""}`}
                          />
                          <ErrorMessage component="div" name="table_name" className="invalid-feedback" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <CustomSelect
                          label="Players"
                          name="players"
                          options={[
                            { value: 2, label: "2 Player" },
                            { value: 3, label: "3 Player" },
                            { value: 4, label: "4 Player" },
                          ]}
                        />
                      </div>
                    </div>

                    <div className="row mt-3">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Prize 1 <span className="text-danger">*</span></label>
                          <Field
                            type="text"
                            name="prize1"
                            placeholder="0.00"
                            className={`mt-1 form-control ${touched.prize1 && errors.prize1 ? "is-invalid" : ""}`}
                            onChange={(e) => {
                              const re = /^[0-9]*\.?[0-9]*$/;
                              if (e.target.value === "" || re.test(e.target.value)) {
                                setFieldValue("prize1", e.target.value);
                              }
                            }}
                          />
                          <ErrorMessage component="div" name="prize1" className="invalid-feedback" />
                        </div>
                      </div>
                    </div>

                    <div className="row mt-3">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Interval Time (Seconds) <span className="text-danger">*</span></label>
                          <Field
                            type="text"
                            name="interval"
                            placeholder="Enter interval"
                            className={`mt-1 form-control ${touched.interval && errors.interval ? "is-invalid" : ""}`}
                            onChange={(e) => {
                              const re = /^[0-9]*$/;
                              if (e.target.value === "" || re.test(e.target.value)) {
                                setFieldValue("interval", e.target.value === "" ? 0 : parseInt(e.target.value));
                              }
                            }}
                          />
                          <ErrorMessage component="div" name="interval" className="invalid-feedback" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Game Time (Seconds) <span className="text-danger">*</span></label>
                          <Field
                            type="text"
                            name="game_time"
                            placeholder="Enter game time"
                            className={`mt-1 form-control ${touched.game_time && errors.game_time ? "is-invalid" : ""}`}
                            onChange={(e) => {
                              const re = /^[0-9]*$/;
                              if (e.target.value === "" || re.test(e.target.value)) {
                                setFieldValue("game_time", e.target.value === "" ? 0 : parseInt(e.target.value));
                              }
                            }}
                          />
                          <ErrorMessage component="div" name="game_time" className="invalid-feedback" />
                        </div>
                      </div>
                    </div>

                    <div className="row mt-3">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Entry Amount <span className="text-danger">*</span></label>
                          <Field
                            type="text"
                            name="amount"
                            placeholder="0.00"
                            className={`mt-1 form-control ${touched.amount && errors.amount ? "is-invalid" : ""}`}
                            onChange={(e) => {
                              const re = /^[0-9]*\.?[0-9]*$/;
                              if (e.target.value === "" || re.test(e.target.value)) {
                                setFieldValue("amount", e.target.value);
                              }
                            }}
                          />
                          <ErrorMessage component="div" name="amount" className="invalid-feedback" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Bonus Amount</label>
                          <Field
                            type="text"
                            name="bonusAmount"
                            placeholder="0.00"
                            className={`mt-1 form-control ${touched.bonusAmount && errors.bonusAmount ? "is-invalid" : ""}`}
                            onChange={(e) => {
                              const re = /^[0-9]*\.?[0-9]*$/;
                              if (e.target.value === "" || re.test(e.target.value)) {
                                setFieldValue("bonusAmount", e.target.value);
                              }
                            }}
                          />
                          <ErrorMessage component="div" name="bonusAmount" className="invalid-feedback" />
                        </div>
                      </div>
                    </div>

                    <div className="row mt-3">
                      <div className="col-md-4">
                        <CustomSelect
                          label="Bot Support"
                          name="bot"
                          options={[
                            { value: 0, label: "Enable" },
                            { value: 1, label: "Disable" },
                          ]}
                        />
                      </div>
                      <div className="col-md-4">
                        <CustomSelect
                          label="Bot Complexity"
                          name="botComplexity"
                          options={[
                            { value: 0, label: "Easy" },
                            { value: 1, label: "Medium" },
                            { value: 2, label: "Hard" },
                          ]}
                        />
                      </div>
                      <div className="col-md-4">
                        <CustomSelect
                          label="Table Status"
                          name="active"
                          options={[
                            { value: true, label: "Active" },
                            { value: false, label: "Inactive" },
                          ]}
                        />
                      </div>
                    </div>

                    <div className="d-flex mt-4">
                      <button
                        type="submit"
                        className="d-flex align-items-center justify-content-center"
                        style={{
                          width: '130px',
                          height: '45px',
                          border: 'none',
                          backgroundColor: '#ffb400',
                          color: '#000',
                          borderRadius: '12px',
                          fontWeight: 'bold',
                          cursor: 'pointer'
                        }}
                        disabled={buttonLoader}
                      >
                        Submit
                        {buttonLoader && (
                          <div className="spinner-border ml-2" role="status" style={{ height: "16px", width: "16px" }} />
                        )}
                      </button>
                      <button
                        onClick={() => setShowPage(false)}
                        type="button"
                        className="btn btn-secondary ml-3"
                        style={{
                          width: '130px',
                          height: '45px',
                          borderRadius: '12px',
                          fontWeight: 'bold'
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </Box>
          </div>
        </div>
      ) : (
        <div className="content p-3">
          <div className="card">
            <div className="pl-4 pr-4 pt-4">
              <div className="row justify-content-end">
                <div className="col-md-6 col-lg-6 d-flex justify-content-end">
                  {accessObject?.addCandyCreamTour === true && (
                    <button
                      onClick={() => openAddTournament(1)}
                      type="button"
                      className="btn btn-primary"
                    >
                      <AddIcon />
                      Add New
                    </button>
                  )}
                </div>
              </div>
            </div>

            <div className="card-body" style={{ overflow: "scroll" }}>
              <table className="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>SrNo</th>
                    <th>Date</th>
                    <th>Table Name</th>
                    <th>Players</th>
                    <th>Prize 1</th>
                    <th>Interval</th>
                    <th>Game Time</th>
                    <th>Amount</th>
                    <th>Bonus Amount</th>
                    <th>Bot</th>
                    <th>Bot Complexity</th>
                    <th>Status</th>
                    {(accessObject?.editCandyCreamTour === true ||
                      accessObject?.deleteCandyCreamTour === true) && (
                        <th style={{ textAlign: "center" }}>Action</th>
                      )}
                  </tr>
                </thead>
                <tbody>
                  {accessObject?.getCandyCreamTour === true ? (
                    <>
                      {!loader ? (
                        <>
                          {tableData.length > 0 ? (
                            <>
                              {tableData
                                .slice(pagination.start, pagination.end)
                                .map((item, index) => (
                                  <tr key={index}>
                                    <td>{index + 1 + pagination.start}</td>
                                    <td style={{ textAlign: "center" }}>
                                      {moment(item.createdAt).format(
                                        "DD/MM/YYYY"
                                      )}
                                    </td>
                                    <td>{item.table_name}</td>
                                    <td>{item.players}</td>
                                    <td>{item.prize1}</td>
                                    <td>{item.interval}</td>
                                    <td>{item.game_time}</td>
                                    <td>{item.amount}</td>
                                    <td>{item.bonusAmount}</td>
                                    <td>{item.bot === 0 ? "Enable" : "Disable"}</td>
                                    <td>
                                      {item.botComplexity === 0
                                        ? "Easy"
                                        : item.botComplexity === 1
                                          ? "Medium"
                                          : "Hard"}
                                    </td>
                                    <td>{item.active ? "Active" : "Inactive"}</td>
                                    {(accessObject?.editCandyCreamTour ===
                                      true ||
                                      accessObject?.deleteCandyCreamTour ===
                                      true) && (
                                        <td className="justify-content-evenly">
                                          <div className="d-flex">
                                            {accessObject?.editCandyCreamTour ===
                                              true && (
                                                <EditIcon
                                                  className="mr-3 courser"
                                                  onClick={() =>
                                                    clickEditButton(item)
                                                  }
                                                />
                                              )}
                                            {accessObject?.deleteCandyCreamTour ===
                                              true && (
                                                <ClearIcon
                                                  className="courser text-danger"
                                                  onClick={() =>
                                                    warningWithConfirmMessage(item)
                                                  }
                                                />
                                              )}
                                          </div>
                                        </td>
                                      )}
                                  </tr>
                                ))}
                            </>
                          ) : (
                            <EmptyState colSpan={14} />
                          )}
                        </>
                      ) : (
                        <tr>
                          <td colSpan={14} className="text-center">
                            <Loader />
                          </td>
                        </tr>
                      )}
                    </>
                  ) : (
                    <tr>
                      <td colSpan={14} className="p-3">
                        <h5 className="text-center mb-0">Access Denied</h5>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            {accessObject?.getCandyTour === true && tableData.length !== 0 && (
              <Pagination
                updateShowPerpagevalue={updateShowPerpagevalue}
                showPrePage={showPrePage}
                onPaginationChange={onPaginationChange}
                total={tableData.length}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
}
